import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOctopus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 244 286",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M104.1 30.25C163.7-19.27 237.4-12.96 242.93 91.2c2.8 52.35-12.88 49.67-76.42 52.96-6.21.32-9.64 13.37.9 16.1 32.82 8.5 16.02 25.28 30.14 45.44 6.4 9.12-9.1 27.68 30.95 79.28 1.97 2.53-7.56-.31-11.02-2.09-19.28-9.87-20.39-25.86-29.04-43.14-16.98-33.9-16.98-61.54-28.01-64.2-4.97-1.2-10.96-2.26-8 5.78 3.93 10.7 9 22.59 2.81 58.42-3.91 22.67-39.2 46.52-36.43 43.14 7.85-9.57 20.6-24.65 24.93-48.67 5.76-31.9-2.02-56.84-11.8-58.67-6.45-1.2-9.71 3.06-9 8.62 1.2 9.26 8.64 24.57-4.13 42.34-16.98 23.61-46.27 41.88-61.86 51.74-4.57 2.89-.4-5.69 4.94-9.28 28.49-19.13 20.05-16.64 34.36-29.22 11.75-10.32 9.18-23.8 10-36.68.59-9.23 2.73-16.42 0-22.92-3.47-8.25-6.8-12.52-10-13.03-3.52-.56-10.62-3.42-13.64 0-11.52 13.03-16.81 15.89-25.66 24.6-18.86 18.55-15.98 44.2-13.38 60.62 1.98 12.55-1.58 8.56-4.2 4.64-4.12-6.13-20.65-35.05-10.46-59.23 2.45-5.8 8.99-15.26 14.66-19.54 29.3-22.12 34.58-21.1 33.72-27.41-.86-6.31-7.93-7.35-28.15 0-36.32 13.2-32.8 43.61-43.44 57s-3.17 3.75-3.17-10.05c0-14.87 18.68-47.12 36.83-55.72 28.1-13.32 43.75 2.82 56.48-26.42 12.73-29.24-51.38-35.83 8.24-85.36Z",
				fill: "#FFDEFB"
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(107.08 106.87)",
				children: [/* @__PURE__ */ _jsx("ellipse", {
					fill: "#D06B46",
					cx: 7.43,
					cy: 7.59,
					rx: 7.43,
					ry: 7.59
				}), /* @__PURE__ */ _jsx("ellipse", {
					fill: "#3137D3",
					cx: 5.57,
					cy: 7.59,
					rx: 5.57,
					ry: 5.69
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(127.93 109.54)",
				children: [/* @__PURE__ */ _jsx("ellipse", {
					fill: "#D06B46",
					cx: 7.43,
					cy: 7.59,
					rx: 7.43,
					ry: 7.59
				}), /* @__PURE__ */ _jsx("ellipse", {
					fill: "#3137D3",
					cx: 5.57,
					cy: 7.59,
					rx: 5.57,
					ry: 5.69
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M150.27 49.36c.68-7.26 11.01-17.7 21.53-16.26 8.15-11.42 16.26-14.54 20.72-16.13 1.42-.51.72-2.51-3.34-2.51-14.46 0-32.66.55-43.13 16.6-7.51-.78-14.24 2.98-19.53 9.92-8.06 1.02-13.91 3.97-15.2 12.5-8.95 3.15-11.64 15.19-3.86 21.01 0 9.44 12.37 13.45 19.58 12.2 0-2.6 1.9-14.27 9.66-18.52-.5-7.9 3.57-16.45 13.57-18.8Z",
				fill: "#A67AEF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M157.62 85.85c3.66 3.67 11.13 4.72 20.84 2.69 6.1 4.28 18.3 5.36 25.91 0 9.85 1.86 24.19-4.12 21-15.26 5.53-3.46 4.18-19.82-1.44-25.74 0-2-9.44-28.02-17.34-30.03-8.91-2.26-18.2-1.9-33.7 17.21-6.09-2.96-18.26 5.32-18.26 14.17-2.52 0-16.73 6.54-14.27 18.72 0 1.07-9.13 5.67-9.13 17.99 0 1.56 6.13-1.07 9.2.25 3.06 1.31 12.83-3.18 17.19 0Z",
				fill: "#A67AEF"
			})
		]
	})
});
export default SvgOctopus;
